import script from "./ViewFile.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewFile.vue?vue&type=script&setup=true&lang=js"

import "./ViewFile.vue?vue&type=style&index=0&id=20e59f3f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20e59f3f"]])

export default __exports__